import { Directive, ElementRef, Attribute } from '@angular/core';
import { uniqueId } from './util';
import * as ɵngcc0 from '@angular/core';
var NgxCardNumberTemplate = (function () {
    function NgxCardNumberTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardNumberTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('number');
    };
NgxCardNumberTemplate.ɵfac = function NgxCardNumberTemplate_Factory(t) { return new (t || NgxCardNumberTemplate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵinjectAttribute('name')); };
NgxCardNumberTemplate.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCardNumberTemplate, selectors: [["", "card-number", ""]], hostVars: 1, hostBindings: function NgxCardNumberTemplate_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("name", ctx.name);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCardNumberTemplate, [{
        type: Directive,
        args: [{
                selector: '[card-number]',
                host: {
                    '[name]': 'name'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['name']
            }] }]; }, null); })();
    return NgxCardNumberTemplate;
}());
export { NgxCardNumberTemplate };
/** @nocollapse */
NgxCardNumberTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
var NgxCardNameTemplate = (function () {
    function NgxCardNameTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardNameTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('name');
    };
NgxCardNameTemplate.ɵfac = function NgxCardNameTemplate_Factory(t) { return new (t || NgxCardNameTemplate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵinjectAttribute('name')); };
NgxCardNameTemplate.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCardNameTemplate, selectors: [["", "card-name", ""]], hostVars: 1, hostBindings: function NgxCardNameTemplate_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("name", ctx.name);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCardNameTemplate, [{
        type: Directive,
        args: [{
                selector: '[card-name]',
                host: {
                    '[name]': 'name'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['name']
            }] }]; }, null); })();
    return NgxCardNameTemplate;
}());
export { NgxCardNameTemplate };
/** @nocollapse */
NgxCardNameTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
var NgxCardExpiryTemplate = (function () {
    function NgxCardExpiryTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardExpiryTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('expiry');
    };
NgxCardExpiryTemplate.ɵfac = function NgxCardExpiryTemplate_Factory(t) { return new (t || NgxCardExpiryTemplate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵinjectAttribute('name')); };
NgxCardExpiryTemplate.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCardExpiryTemplate, selectors: [["", "card-expiry", ""]], hostVars: 1, hostBindings: function NgxCardExpiryTemplate_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("name", ctx.name);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCardExpiryTemplate, [{
        type: Directive,
        args: [{
                selector: '[card-expiry]',
                host: {
                    '[name]': 'name'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['name']
            }] }]; }, null); })();
    return NgxCardExpiryTemplate;
}());
export { NgxCardExpiryTemplate };
/** @nocollapse */
NgxCardExpiryTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };
var NgxCardCvcTemplate = (function () {
    function NgxCardCvcTemplate(elementRef, name) {
        this.elementRef = elementRef;
        this.name = name;
    }
    NgxCardCvcTemplate.prototype.ngOnInit = function () {
        this.name = this.name || uniqueId('cvc');
    };
NgxCardCvcTemplate.ɵfac = function NgxCardCvcTemplate_Factory(t) { return new (t || NgxCardCvcTemplate)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵinjectAttribute('name')); };
NgxCardCvcTemplate.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxCardCvcTemplate, selectors: [["", "card-cvc", ""]], hostVars: 1, hostBindings: function NgxCardCvcTemplate_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("name", ctx.name);
    } } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxCardCvcTemplate, [{
        type: Directive,
        args: [{
                selector: '[card-cvc]',
                host: {
                    '[name]': 'name'
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Attribute,
                args: ['name']
            }] }]; }, null); })();
    return NgxCardCvcTemplate;
}());
export { NgxCardCvcTemplate };
/** @nocollapse */
NgxCardCvcTemplate.ctorParameters = function () { return [
    { type: ElementRef, },
    { type: undefined, decorators: [{ type: Attribute, args: ['name',] },] },
]; };

